// Глобальные события для pub/sub
window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || {
  cartUpdate: 'cartUpdate',
  quantityUpdate: 'quantityUpdate',
  cartError: 'cartError',
  variantChange: 'variantChange',
  optionValueSelectionChange: 'optionValueSelectionChange'
};

window.ON_CHANGE_DEBOUNCE_TIMER = window.ON_CHANGE_DEBOUNCE_TIMER || 300;

// Если subscribe/publish не определены, определяем их (совместимость с pubsub.js)
if (typeof window.subscribe !== 'function' || typeof window.publish !== 'function') {
  let subscribers = {};
  window.subscribe = function(eventName, callback) {
    if (subscribers[eventName] === undefined) {
      subscribers[eventName] = [];
    }
    subscribers[eventName] = [...subscribers[eventName], callback];
    return function unsubscribe() {
      subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
    };
  };
  window.publish = function(eventName, data) {
    if (subscribers[eventName]) {
      const promises = subscribers[eventName].map((callback) => callback(data));
      return Promise.all(promises);
    } else {
      return Promise.resolve();
    }
  };
}
